import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import GridViewMUIX from "src/components/GridViewMUIX";
import {
  ListOfStatusGlobal,
  StatusGlobal,
} from "src/interface/enum/StatusGlobal";
import renderCellExpand from "src/GridComponents/GridExpand";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";
import moment from "jalali-moment";
import { ITaskLog } from "src/interface/ITaskLog";
import { Chip } from "@mui/material";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowBackIosIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: "rotate(90deg)",
    },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
  ...theme.applyStyles("dark", {
    backgroundColor: "rgba(255, 255, 255, .05)",
  }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function NeededHistory({
  getEditors,
  LogsData,
  isLoading,
}: {
  getEditors: IAutoCompleteLabelValue[];
  LogsData: ITaskLog[];
  isLoading: boolean;
}) {
  const [expanded, setExpanded] = React.useState<string | false>("");

  const columns: GridColDef[] = [
    {
      field: "userRef",
      headerName: "کارمند",
      sortable: false,
      type: "singleSelect",
      valueOptions: getEditors,
      minWidth: 140,
    },
    {
      field: "statusTask",
      headerName: "وضعیت",
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => (
        <Chip
          label={
            ListOfStatusGlobal.find(
              (g) =>
                g.value ===
                (params.value ? params.value : StatusGlobal.NotStarted)
            )?.label
          }
          //@ts-ignore
          color={
            ListOfStatusGlobal.find(
              (g) =>
                g.value ===
                (params.value ? params.value : StatusGlobal.NotStarted)
            )?.color
          }
          variant="filled"
        />
      ),
      minWidth: 180,
    },
    {
      field: "statusDesc",
      headerName: "توضیحات",
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: renderCellExpand,
      minWidth: 100,
    },
    {
      field: "createdOn",
      headerName: "تاریخ ثبت",
      sortable: true,
      headerAlign: "center",
      width: 150,
      align: "center",
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment
            .from(params.value, "en", "YYYY-MM-DD-HH:mm")
            .format("jYYYY/jMM/jDD-HH:mm")
        }`,
    },
  ];

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <div>
      <Accordion
        // expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>
            نیاز به نمایش تاریخچه: {expanded === "panel2" ? "دارم" : "ندارم"}
          </Typography>{" "}
        </AccordionSummary>
        <AccordionDetails>
          <GridViewMUIX
            rows={LogsData}
            loading={isLoading}
            sortFields={{ field: "createdOn", sort: "desc" }}
            columns={columns}
            rowHeight={30}
            disableColumnFilter
            disableColumnMenu
            disableColumnSelector
            disableDensitySelector
            pageSize={20}
            gridUniqueName="NeededHistory"
          />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
